// Carrito desplegable: recuadro que baja desde el ícono del carrito; se abre al tocarlo y al agregar un producto.
// Cambiar cantidad o eliminar lo resuelve theme.js (data-cart-section / data-cart-line).
(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  const root = window.Shopify?.routes?.root || '/';
  const panel = () => drawer.querySelector('[data-cart-section]');
  let lastFocus = null;

  // Coloca el recuadro justo debajo del ícono del carrito, con la flechita apuntándolo
  const place = () => {
    const icon = document.querySelector(`[data-cart-open], .header a[href="${root}cart"]`);
    if (!icon) return;
    const r = icon.getBoundingClientRect();
    const width = Math.min(400, window.innerWidth - 24);
    const right = Math.min(Math.max(12, window.innerWidth - r.right - 4), window.innerWidth - width - 12);
    drawer.style.setProperty('--drawer-top', `${Math.max(8, r.bottom + 10)}px`);
    drawer.style.setProperty('--drawer-right', `${right}px`);
    drawer.style.setProperty('--drawer-arrow', `${Math.max(14, window.innerWidth - right - r.right + r.width / 2 - 6)}px`);
  };
  window.addEventListener('resize', () => !drawer.hidden && place());

  const open = () => {
    lastFocus = document.activeElement;
    place();
    drawer.hidden = false;
    requestAnimationFrame(() => requestAnimationFrame(() => drawer.classList.add('is-open')));
    panel().focus();
  };
  const close = () => {
    if (drawer.hidden) return;
    drawer.classList.remove('is-open');
    setTimeout(() => { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 250);
    lastFocus?.focus?.();
  };
  const refresh = async () => {
    const html = await (await fetch(`${root}cart?section_id=cart-drawer`)).text();
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-section]');
    if (fresh) panel().innerHTML = fresh.innerHTML;
  };

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-close]')) return close();
    const opener = e.target.closest(`[data-cart-open], .header a[href="${root}cart"]`);
    if (opener && !e.metaKey && !e.ctrlKey) {
      e.preventDefault();
      drawer.hidden ? open() : close();
    }
  });
  document.addEventListener('keydown', (e) => e.key === 'Escape' && close());

  // "Agregar al carrito" en la página de producto: agrega y abre el carrito lateral
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    e.stopPropagation();
    const btn = form.querySelector('[data-add-to-cart]');
    if (btn) btn.disabled = true;
    try {
      const res = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || 'No se pudo agregar');
      const cart = await (await fetch(`${root}cart.js`)).json();
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
      await refresh();
      open();
    } catch (err) {
      alert(err.message);
    } finally {
      if (btn) btn.disabled = false;
    }
  }, true);
})();
